import {Controller} from 'stimulus'

import {useIntersection} from 'stimulus-use'
import $ from "jquery";
import {formattedPriceUtils} from "../utils/currencyUtils";

export default class extends Controller {
    connect() {
        this.appId = this.element.dataset.appid;
        this.apiKey = this.element.dataset.apikey;
        this.indexPrefix = this.element.dataset.indexprefix;
        this.currency = this.element.dataset.currency;

        this.isInit = false; // Track initialization state

        $('.algolia-search .toggle-filter').click(function (e) {
            $('.algolia-search #filters').slideToggle(function () {
                $('.algolia-search #filters').toggleClass('active');
            });
            e.preventDefault();
        });

        document.addEventListener("click", (event) => {
            const searchContainer = $(".algolia-search")[0];
            const searchForm = $("#instant-search-form")[0];
            const filters = document.querySelector('#filters');
            const removeFilterButton = event.target.closest('.ais-CurrentRefinements-delete');

            if (
                this.isInit &&
                searchContainer &&
                !searchContainer.contains(event.target) &&
                searchForm &&
                !searchForm.contains(event.target) &&
                filters &&
                !filters.contains(event.target) &&
                !removeFilterButton
            ) {
                console.log("close");
                this.searchDispose();
            }
        });
    }

    isMobile() {
        return window.matchMedia("(max-width: 767px)").matches; // Adjust max-width as needed
    }

    searchInit() {
        event.preventDefault();
        let _self = this;
        setTimeout(() => {
            if (!this.isInit) {
                // Create a new search instance
                const searchClient = algoliasearch(this.appId, this.apiKey);

                console.log(searchClient);
                this.search = instantsearch({
                    indexName: this.indexPrefix,
                    searchClient,
                });

                this.search.addWidgets([
                    instantsearch.widgets.configure({
                        hitsPerPage: 24,
                    }),
                    instantsearch.widgets.searchBox({
                        container: '#searchbox',
                        placeholder: 'Търси продукт, категория, марка...',
                    }),
                    instantsearch.widgets.hits({
                        container: '#hits',
                        transformItems(items) {
                            console.log(items);
                            return items.map(item => ({
                                ...item,
                                formattedDiscountedPrice: formattedPriceUtils(item.price, 'EUR', false),
                                formattedPrice: formattedPriceUtils(item.discountedPrice, 'EUR', false),
                                hasDiscount: item.discountedPrice != item.price?'':'d-none',
                                isNew: item.isNew == 1 ? '' : 'd-none',
                                outOfStock: item.isInStock == 0 ? 'out-of-stock' : '',
                                outOfStockLabel: item.isInStock == 1 ? 'd-none' : '',
                                labels: _self.getLabelsHtml(item),
                                discountPercent: _self.calculateDiscountPercent(item),
                            }));
                        },
                        cssClasses: {
                            list: '',
                            item: 'product-item',
                            label: '',
                            category: '',
                            delete: '',
                        },
                        templates: {
                            item: `
                    <div class="position-relative {{outOfStock}} pt-4">
                        <ul class="product-labels">
                        <li class="product-label label-discount {{hasDiscount}}">{{discountPercent}}%</li>
                        {{{labels}}}
                        <li class="product-label label-out-of-stock {{outOfStockLabel}}">Изчерпан</li>
                        </ul>
                        <a href="{{url}}"><img src="{{image}}" alt="{{name}}" style="width: 100px;" /></a>
                        <a href="{{url}}"><h3>{{name}}</h3></a>
                        <ul class="stars d-flex justify-content-center"><li><img src="/build/images/icons/star.svg" alt="star logo"></li> <li><img src="/build/images/icons/star.svg" alt="star logo"></li> <li><img src="/build/images/icons/star.svg" alt="star logo"></li> <li><img src="/build/images/icons/star.svg" alt="star logo"></li> <li><img src="/build/images/icons/star.svg" alt="star logo"></li></ul>
                        <div class="product-prices">
                        
                            <div class="old-price {{hasDiscount}}">
                            <span class="strike">{{{formattedDiscountedPrice}}}</span>
                            </div>
                        
                            <div class="price">{{{formattedPrice}}}</div>
                        </div>
                    </div>
                    `,
                        },
                    }),
                    instantsearch.widgets.pagination({
                        container: '#pagination',
                        scrollTo: '#hits',


                    }),
                    instantsearch.widgets.refinementList({
                        container: '#category-filter',
                        attribute: 'defaultCategory.name',
                        showMore: true,
                    }),
                    instantsearch.widgets.refinementList({
                        container: '#manufacturer-filter',
                        attribute: 'manufacturer.name',
                        showMore: true,
                    }),
                    instantsearch.widgets.stats({
                        container: '#stats',
                        templates: {
                            text: data => `${data.nbHits} резултата от търсене`,
                        },
                    }),
                    instantsearch.widgets.clearRefinements({
                        container: '.clear-all',
                        templates: {
                            resetLabel: 'Изчисти всички филтри',
                        },
                    }),

                    instantsearch.widgets.currentRefinements({
                        container: '.selected-filters-list',
                        cssClasses: {
                            list: 'list-item',
                            item: '',
                            label: '',
                            category: '',
                            delete: '',
                        },
                    }),


                ]);

                this.search.on('render', () => {
                    const clearAllButton = document.querySelector('.clear-all button');
                    const list = document.querySelector('.selected-filters-list');
                    const items = list ? list.querySelectorAll('.ais-CurrentRefinements-item') : [];
                    if (clearAllButton) {
                        if (clearAllButton.disabled) {
                            clearAllButton.style.display = 'none';
                        } else {
                            clearAllButton.style.display = 'inline-block';
                        }
                    }
                    if (list) {
                        if (items.length === 0) {
                            list.style.display = 'none';
                        } else {
                            list.style.display = 'flex';
                        }
                    }
                });

                this.search.on('render', () => {
                    const offset = 200;
                    const hasResults = document.querySelector('#hits .ais-Hits-item') !== null;

                    const filterContainer = document.querySelector('#filters');
                    if (filterContainer) {
                        if (hasResults) {
                            filterContainer.classList.remove('d-none');
                        } else {
                            filterContainer.classList.add('d-none');
                        }
                    }

                    const paginationContainer = document.querySelector('#pagination');
                    if (paginationContainer) {
                        if (hasResults) {
                            paginationContainer.classList.remove('d-none');
                        } else {
                            paginationContainer.classList.add('d-none');
                        }
                    }

                    const paginationButtons = document.querySelectorAll('#pagination .ais-Pagination-link');
                    paginationButtons.forEach((button) => {
                        button.addEventListener('click', () => {
                            setTimeout(() => {
                                const targetElement = document.querySelector('#hits');
                                const topPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
                                window.scrollTo({ top: topPosition, behavior: 'smooth' });
                            }, 0);
                        });
                    });
                });


                this.search.start();

                // Show the search container
                const searchContainer = document.querySelector('.algolia-search');
                if (searchContainer) {
                    searchContainer.style.display = 'block'; // Make it visible again
                }

                if (!this.isMobile()) {
                    const filterContainer = document.querySelector('#filters');
                    if (filterContainer) {
                        filterContainer.style.display = 'block'; // Make it visible again
                    }
                }


                // Set focus on the search box
                const searchInput = document.querySelector('#searchbox input');
                if (searchInput) {
                    searchInput.focus();
                }

                this.isInit = true; // Mark as initialized
                document.body.classList.add('instant-open');
            } else {
                // If already initialized, just show the container
                const searchContainer = document.querySelector('.algolia-search');
                if (searchContainer) {
                    searchContainer.style.display = 'block';
                }
                document.body.classList.add('instant-open');
            }

            document.querySelector('#filters').addEventListener('click', (event) => {
                event.stopPropagation();
            });


        }, 100);


    }

    convertToEuro(price){
        return formattedPriceUtils(price, 'EUR');
    }
    searchDispose() {
        if (this.search) {
            // Stop and dispose of the search instance
            this.search.dispose();

            // Hide the search container
            const searchContainer = document.querySelector('.algolia-search');
            if (searchContainer) {
                searchContainer.style.display = 'none'; // Hide the container
            }

            // Remove any open class or states
            document.body.classList.remove('instant-open');
            this.isInit = false; // Reset initialization flag
        }
    }
    calculateDiscountPercent(item){
        return (((item.price - item.discountedPrice) / item.price) * -100).toFixed(0);
    }
    getLabelsHtml(item){
        let html = '';

        item.labels.forEach((label) => {
            html += '<li class="product-label" style="background-color: ' + label.color + ';">' + label.label + '</li>';
        });

        return html;
    }
    disconnect() {
        if (this.isInit) {
            document.body.classList.remove('instant-open');
        }
    }

}